import TitleDashboard from "@components/general/Titles/TitleDashboard";
import Loader from "@helpers/loader/loader";
import { Typography } from "@mui/material";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Animated } from "react-animated-css";
import { Accordion, Card, Col, Container, Form, Image, Navbar, Row } from "react-bootstrap";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import AccordionDatosPersonales from "./accordionItems/AccordionDatosPersonales";
import AccordionDatosDomicilio from "./accordionItems/AccordionDatosDomicilio";
import AccordionDatosCredito from "./accordionItems/AccordionDatosCredito";
import AccordionAutorizacionContrato from "./accordionItems/AccordionAutorizacionContrato";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import UserContext from "@context/User/UserContext";
import { typesOpcionesPagoCompra } from "@helpers/types/typesOpcionesPagoCompra";
import { NotificationManager } from "react-notifications";
import { emailValidator, phoneNumberValidator } from "@helpers/validaciones/validaciones";
import typesMetodosPago from "@helpers/types/typesMetodosPago";
import { actualizarDatosFirma, enviarDomiciliacionSai, generarDomiciliacion, procesarDatosPreRegistro, subirFotosSai, validarDatosPreRegistro } from "@helpers/httpRequests/httpRequestsSAI/httpRequestsSAI";
import { retrievePaymentIntent } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import getPrecioFormateado from "@helpers/formateoPrecios/getPreciosFormateado";
import typesMesesFecha from "@helpers/types/typesMesesFecha";
import getFilledPdfBytes from "@helpers/pdf/getFilledPdfBytes/getFilledPdfBytes";
import getPdfScreenshot from "@helpers/pdf/getPdfScreenshot/getPdfScreenshot";

import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import numberCommaSeparator from "@helpers/formateoPrecios/numberCommaSeparator";
import { enviarComprobanteCompra } from "@helpers/httpRequests/httpRequestsMailers/httpRequestsMailers";
import AccordionDatosDomicilioExterno from "./accordionItems/FormsDomicilioRegiones/AccordionDatosDomicilioExterno";

const particlesOptions = {
	fpsLimit: 60,
	particles: {
		number: {
			value: 100,
			density: {
				enable: true,
			},
		},
		color: {
			value: ["#ffcc00", "#757676", "#ff9900", "#00152A", "#f07f13"],
		},
		opacity: {
			value: { min: 0.1, max: 0.5 },
		},
		size: {
			value: { min: 1, max: 3 },
		},
		move: {
			enable: true,
			speed: 6,
			random: false,
		},
	},
	interactivity: {
		detectsOn: "window",
		events: {
			onClick: {
				enable: true,
				mode: "push",
			},
			resize: true,
		},
	},
	background: {
		// image: "radial-gradient(#4a0000, #000)",
		image: "radial-gradient(#01488f, rgba(0, 21, 42, 1))",
	},
};

const validarCamposVacios = ({ formValues, isCreditoDirecto, setCamposVacios, setEventKey, metodoPago }) => {
	return new Promise(async (resolve, reject) => {
		try {
			for (const formValue in formValues) {
				if (Object.hasOwnProperty.call(formValues, formValue)) {
					const element = formValues[formValue];

					if (element === "") {
						let message = "";

						switch (formValue) {
							// Personales
							case "nombre":
								message = "Ingresa tu nombre completo";
								break;
							case "apellidoPaterno":
								message = "Ingresa tu apellido paterno";
								break;
							case "apellidoMaterno":
								message = "Ingresa tu apellido materno";
								break;
							case "numeroTelefono":
								message = "Ingresa tu número de teléfono a 10 dígitos";
								break;
							case "correo":
								message = "Ingresa tu correo electrónico";
								break;
							case "edad":
								message = "Ingresa tu edad actual";
								break;
							case "estadoCivil":
								message = "Elige tu estado civil actual";
								break;

							// Domicilio
							case "codigoPostal":
							case "ciudad":
							case "estado":
								message = "Ingresa tu código postal";
								break;
							case "calle":
								message = "Ingresa tu calle";
								break;
							case "colonia":
								message = "Ingresa tu colonia";
								break;
							case "numeroExterior":
								message = "Ingresa el número exterior de tu domicilio";
								break;
							case "entreCalles":
								if (isCreditoDirecto) {
									message = "Ingresa entre qué calles se encuentra tu domicilio";
								}
								break;
							case "tiempoResidencia":
								if (isCreditoDirecto) {
									message = "Ingresa cuánto tiempo tienes residiendo en tu domicilio";
								}
								break;

							// Empleo
							case "nombreReferencia1":
								if (isCreditoDirecto) {
									message = "Ingresa el nombre de tu primera referencia";
								}
								break;
							case "parentescoReferencia1":
								if (isCreditoDirecto) {
									message = "Ingresa el parentesco con tu primera referencia";
								}
								break;
							case "numeroTelefonoReferencia1":
								if (isCreditoDirecto) {
									message = "Ingresa un número de teléfono de 10 dígitos de primera referencia";
								}
								break;
							case "nombreReferencia2":
								if (isCreditoDirecto) {
									message = "Ingresa el nombre de tu segunda referencia";
								}
								break;
							case "parentescoReferencia2":
								if (isCreditoDirecto) {
									message = "Ingresa el parentesco con tu segunda referencia";
								}
								break;
							case "numeroTelefonoReferencia2":
								if (isCreditoDirecto) {
									message = "Ingresa un número de teléfono de 10 dígitos de segunda referencia";
								}
								break;
							case "nombreEmpresa":
								if (isCreditoDirecto) {
									message = "Ingresa el nombre de tu empresa";
								}
								break;
							case "numeroTelefonoEmpresa":
								if (isCreditoDirecto) {
									message = "Ingresa un número de teléfono de 10 dígitos de tu empresa";
								}
								break;
							case "puesto":
								if (isCreditoDirecto) {
									message = "Ingresa el puesto que ocupas en tu empresa";
								}
								break;
							case "antiguedad":
								if (isCreditoDirecto) {
									message = "Ingresa cuántos años tienes trabajando en tu empresa";
								}
								break;
							case "inicioHorarioLaboral":
								if (isCreditoDirecto) {
									message = "Ingresa la hora de inicio de tu horario laboral";
								}
								break;
							case "finHorarioLaboral":
								if (isCreditoDirecto) {
									message = "Ingresa la hora de fin de tu horario laboral";
								}
								break;

							// Autorizacion
							case "caraFrontalIne":
								if (isCreditoDirecto) {
									message = "Carga la cara frontal de tu INE";
								}
								break;
							case "caraPosteriorIne":
								if (isCreditoDirecto) {
									message = "Carga la cara posterior de tu INE";
								}
								break;
							case "caraFrontalTarjeta":
								if (isCreditoDirecto) {
									message = "Carga la cara frontal de tu tarjeta de débito";
								}
								break;
							case "firma":
								message = "Genera tu firma de contrato";
								break;

							default:
								break;
						}

						if (message !== "") {
							switch (formValue) {
								// Personales
								case "nombre":
								case "apellidoPaterno":
								case "apellidoMaterno":
								case "numeroTelefono":
								case "correo":
								case "edad":
								case "estadoCivil":
									setEventKey("1");
									break;

								// Domicilio
								case "codigoPostal":
								case "calle":
								case "colonia":
								case "ciudad":
								case "estado":
								case "numeroExterior":
								case "entreCalles":
								case "tiempoResidencia":
									setEventKey("2");
									break;

								// Empleo
								case "nombreEmpresa":
								case "numeroTelefonoEmpresa":
								case "puesto":
								case "antiguedad":
								case "inicioHorarioLaboral":
								case "finHorarioLaboral":
								case "nombreReferencia1":
								case "parentescoReferencia1":
								case "numeroTelefonoReferencia1":
								case "nombreReferencia2":
								case "parentescoReferencia2":
								case "numeroTelefonoReferencia2":
									setEventKey("3");
									break;

								// Autorizacion
								case "caraFrontalIne":
								case "caraPosteriorIne":
								case "caraFrontalTarjeta":
								case "firma":
									setEventKey("4");
									break;

								default:
									break;
							}

							return reject(message);
						}
					} else {
						let message = "";

						let eventKey = "";

						switch (formValue) {
							case "numeroTelefono":
							case "numeroTelefonoReferencia1":
							case "numeroTelefonoReferencia2":
							case "numeroTelefonoEmpresa":
								const numeroTelefonoValido = phoneNumberValidator(element);

								if (!numeroTelefonoValido) {
									eventKey = metodoPago !== typesMetodosPago.CREDITO ? "1" : "3";

									switch (formValue) {
										case "numeroTelefono":
											message = "Ingresa tu número de teléfono a 10 dígitos";
											break;

										case "numeroTelefonoReferencia1":
											message = "Ingresa un número de teléfono de 10 dígitos de tu empresa";
											break;

										case "numeroTelefonoReferencia2":
											message = "Ingresa un número de teléfono de 10 dígitos de primera referencia";
											break;

										case "numeroTelefonoEmpresa":
											message = "Ingresa un número de teléfono de 10 dígitos de segunda referencia";
											break;

										default:
											break;
									}
								}

								break;

							case "correo":
								const correoValido = emailValidator(element);

								if (!correoValido) {
									eventKey = "1";

									message = "Ingresa un correo válido";
								}
								break;

							case "edad":
								if (element.length < 2) {
									eventKey = "1";

									message = "Ingresa tu edad correcta";
								}
								break;

							case "codigoPostal":
								if (element.length < 5) {
									eventKey = "2";

									message = "Ingresa un código postal válido";
								}
								break;

							case "inicioHorarioLaboral":
							case "finHorarioLaboral":
								if (element === "-- Selecciona un horario --") {
									eventKey = "3";

									message = `Ingresa un horario de ${formValue.includes("inicio") ? "entrada" : "salida"} de tu empleo`;
								}
								break;

							default:
								break;
						}

						if (message !== "") {
							setEventKey(eventKey);

							return reject(message);
						}
					}
				}
			}

			setCamposVacios(false);

			resolve(true);
		} catch (error) {
			reject(error);
		}
	});
};

const getArrayJsonCargaImagenes = ({idRegion, folioContrato, imagesData }) => {
	return new Promise(async (resolve, reject) => {
		try {
			let arrayJSONFotos = [
				{
					idRegion,
					folioContrato,
					nombreFoto: "03_ife_frente",
					fotoBase64: imagesData.caraFrontalIne,
				},
				{
					idRegion,
					folioContrato,
					nombreFoto: "04_ife_atras",
					fotoBase64: imagesData.caraPosteriorIne,
				},
				{
					idRegion,
					folioContrato,
					nombreFoto: "06_tc",
					fotoBase64: imagesData.caraFrontalTarjeta,
				},
			];

			resolve(arrayJSONFotos);
		} catch (error) {
			console.log(error);

			reject(error);
		}
	});
};

const getFechaString = (date) => {
	let months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

	let year = date.getFullYear();

	let month = months[date.getMonth()];

	let day = date.getDate();

	let formattedDate = day + " de " + month + " del " + year;

	return formattedDate;
};

const getTemplateReplacements = ({ formValues, precios }) => {
	return new Promise(async (resolve, reject) => {
		try {
			const fechaDomiciliacion = new Date();

			const QUINCENAS_POR_MES = 2;

			const COSTO_TOTAL = precios.credito.precioTotal;

			const PAGO_QUINCENAL = precios.credito.pagoQuincenal;

			const QUINCENAS_TOTALES = COSTO_TOTAL / PAGO_QUINCENAL;
			
			const cantidadMeses = QUINCENAS_TOTALES / QUINCENAS_POR_MES;

			const fechaVencimiento = new Date();

			fechaVencimiento.setMonth(fechaDomiciliacion.getMonth() + cantidadMeses);

			resolve({
				tipoLicencia: "Licencia Click+ Premium",
				nombreBanco: formValues.bancoEmisor,
				numeroTarjeta: formValues.numeroTarjetaDomiciliacion,
				montoMaximo: await getPrecioFormateado(precios.credito.precioTotal),
				montoFijo: await getPrecioFormateado(precios.credito.pagoQuincenal),
				nombreTitular: formValues.titularTarjetaDomiciliacion,
				firmaTitular: formValues.firma,
				diasPago: "Días 1 y 15",
				fechaVencimiento: getFechaString(fechaVencimiento),
			});
		} catch (error) {
			console.log(error);

			reject(error);
		}
	});
};

const getFechaDomiciliacion = () => {
	let nombreMes = '';
	let mes = new Date().getMonth() + 1;

	switch (mes) {
		case typesMesesFecha.enero.digito:
			nombreMes = typesMesesFecha.enero.letra;
			break;

		case typesMesesFecha.febrero.digito:
			nombreMes = typesMesesFecha.febrero.letra;
			break;

		case typesMesesFecha.marzo.digito:
			nombreMes = typesMesesFecha.marzo.letra;
			break;

		case typesMesesFecha.abril.digito:
			nombreMes = typesMesesFecha.abril.letra;
			break;

		case typesMesesFecha.mayo.digito:
			nombreMes = typesMesesFecha.mayo.letra;
			break;

		case typesMesesFecha.junio.digito:
			nombreMes = typesMesesFecha.junio.letra;
			break;

		case typesMesesFecha.julio.digito:
			nombreMes = typesMesesFecha.julio.letra;
			break;

		case typesMesesFecha.agosto.digito:
			nombreMes = typesMesesFecha.agosto.letra;
			break;

		case typesMesesFecha.septiembre.digito:
			nombreMes = typesMesesFecha.septiembre.letra;
			break;

		case typesMesesFecha.octubre.digito:
			nombreMes = typesMesesFecha.octubre.letra;
			break;

		case typesMesesFecha.noviembre.digito:
			nombreMes = typesMesesFecha.noviembre.letra;
			break;

		case typesMesesFecha.diciembre.digito:
			nombreMes = typesMesesFecha.diciembre.letra;
			break;

		default:
			break;
	}

    return {
        dia: new Date().getDate().toString(),
        mes: nombreMes,
        anio: new Date().getFullYear().toString().substring(2, 4)
    }
};

const generarDocumentoDomiciliacion = ({ folioContrato, replacements, idRegion }) => {
	return new Promise(async (resolve, reject) => {
        try {
			const data = await fetch(`${ window.location.origin }/assets/templates/domiciliacion/pdf_domiciliacion.pdf`);
			
			const pdfTemplateBytes = await data.arrayBuffer();

			const fechaDomiciliacion = getFechaDomiciliacion();

			const filledPdfBytes = await getFilledPdfBytes({ pdfTemplateBytes, replacements, fechaDomiciliacion });
			
			const formData = new FormData();
			
			formData.append('filledPdf', new Blob([ filledPdfBytes.buffer ]));
			
			const pathPDF = await generarDomiciliacion(formData, folioContrato);

			const pdfScreenshotBytes = await getPdfScreenshot({ filledPdfBytes });
			
			await enviarDomiciliacionSai({
				pathPDF,
				pdfImageBase64: pdfScreenshotBytes
			}, folioContrato, idRegion);

			resolve(true);
        } catch (error) {
            console.log("error al generar el documento de domiciliación: ", error);

            reject(error);
        }
    });
};

const enviarComprobante = (datosComprobante, formValues, datosCompra, paymentMethod, paymentIntent, compraLectura, esCompraExterna) => {
	return new Promise(async (resolve, reject) => {
		try {
			
			const { folioContrato, nombre, apellidoPaterno, apellidoMaterno, correo } = formValues;
			
			const { metodoPago, preciosSeleccionados: precios  } = datosCompra;
			
			const { card: { last4 } } = paymentMethod;
			
			const { id: paymentIntentId, amount: montoCobro, payment_method_options: { card } } = paymentIntent;
			
			const titular = `${nombre.trim()} ${apellidoPaterno.trim()} ${apellidoMaterno.trim()}`;

			let pagoMetodo = "";

			switch (metodoPago) {
				case "contado":
					if(card.installments.plan !== null){
						pagoMetodo = `${card.installments.plan.count} Meses sin intereses`;
					}else{
						pagoMetodo = "De contado";
					}
					break;

				case "credito":
					pagoMetodo = "Crédito Directo"
				break;

				case "msi":
					pagoMetodo = `${card.installments.plan.count} Meses sin intereses`
				break;
			
				default:
					break;
			}

			let replacements = {};
			// if(compraLectura){
				replacements = {
				folioContrato,
				titular,
				numeroTarjeta: `Tarjeta con terminación ${ last4 }`,
				// metodoPago: metodoPago === "contado" ? "De contado" : metodoPago === "credito" ? "Crédito Directo" : `${card.installments.plan.count} Meses sin intereses`,
				metodoPago: pagoMetodo,
				description: compraLectura ? `Compra de curso de Lectura Inteligente - Folio ${folioContrato}` :  `Compra de Licencia Click+ Premium - Folio ${folioContrato}`,
				paymentIntentId,
				correo,
				montoCobro: numberCommaSeparator(montoCobro / 100),
				costoBase: compraLectura ? numberCommaSeparator(datosComprobante.montoCobro) : metodoPago === "contado" ? numberCommaSeparator(precios.contado) : metodoPago === "credito" ? numberCommaSeparator(precios.credito.precioTotal) : numberCommaSeparator(precios.msi.monto),
				...(metodoPago === "credito"
					? {
							cantidadRestante: numberCommaSeparator(precios.credito.precioTotal - (montoCobro / 100)),
						}
					: metodoPago.includes("msi")
					? {
							msi: card.installments.plan.count
						}
					: {}),
				currency: esCompraExterna? "USD" : "MXN"
			};
			
			// // }
	
			await enviarComprobanteCompra(replacements);

			resolve();
		} catch (error) {
			console.log("Error al enviar el comprobante de compra: ", error);

			reject(error);
		}
	});
};

const enviarComprobanteKueski = (datosComprobante, formValues, kueskiSession, kueskiAmount, compraLectura) => {
	return new Promise(async (resolve, reject) => {
		try {
			
			const { folioContrato, nombre, apellidoPaterno, apellidoMaterno, correo } = formValues;
						
			
			const titular = `${nombre.trim()} ${apellidoPaterno.trim()} ${apellidoMaterno.trim()}`;

	
			let replacements = {};
			// if(compraLectura){
				 replacements = {
					folioContrato,
					titular,
					numeroTarjeta: `Tarjeta usada desde Kueski Pay`,
					metodoPago: "Compra con Kueski Pay",
					description: compraLectura ? `Compra de curso de Lectura Inteligente - Folio ${folioContrato}` :  `Compra de Licencia Click+ Premium - Folio ${folioContrato}`,
					paymentIntentId: kueskiSession.payment_intent,
					correo,
					montoCobro: numberCommaSeparator(kueskiAmount / 100),
					costoBase:  numberCommaSeparator(datosComprobante.montoCobro),
				};
			
			// }
	
			await enviarComprobanteCompra(replacements);

			resolve();
		} catch (error) {
			console.log("Error al enviar el comprobante de compra: ", error);

			reject(error);
		}
	});
};


const FormularioRegistroSAI = ({ history }) => {
	const [eventKey, setEventKey] = useState("4");

	const buttonRef = useRef();

	const { folioContrato } = useParams();

	const { contextValue, setContextValue } = useContext(UserContext);

	const {
		compra: {compraLectura, compraKueski=false, kueskiAmount = 0, stripeSession, kueskiSession = {}, codigoAplicado, idCodigoDescuento, preciosSeleccionados: precios }
	} = contextValue;

	
	const [showLoader, setShowLoader] = useState(true);

	const [loading, setLoading] = useState(false);

	const [isCreditoDirecto, setIsCreditoDirecto] = useState(false);

	const [paymentIntent, setPaymentIntent] = useState({});

	const [paymentMethod, setPaymentMethod] = useState({});

	const [camposVacios, setCamposVacios] = useState(true);

	const [compraExterna, setCompraExterna] = useState(false);

	const [formValues, setFormValues] = useState({
		folioContrato,
		nombre: "",
		apellidoPaterno: "",
		apellidoMaterno: "",
		numeroTelefono: "",
		correo: "",
		edad: "",
		estadoCivil: "",
		codigoPostal: "",
		calle: "",
		colonia: "",
		ciudad: "",
		estado: "",
		numeroExterior: "",
		numeroInterior: "",
		entreCalles: "",
		tiempoResidencia: "",
		nombreEmpresa: "",
		numeroTelefonoEmpresa: "",
		puesto: "",
		antiguedad: "",
		inicioHorarioLaboral: "",
		finHorarioLaboral: "",
		nombreReferencia1: "",
		parentescoReferencia1: "",
		numeroTelefonoReferencia1: "",
		nombreReferencia2: "",
		parentescoReferencia2: "",
		numeroTelefonoReferencia2: "",
		caraFrontalIne: "",
		caraPosteriorIne: "",
		caraFrontalTarjeta: "",
		firma: "",
		numeroTarjetaDomiciliacion: '',
		titularTarjetaDomiciliacion: '',
		bancoEmisor: "",
		region: 1,
	});

	const particlesInit = useCallback(async (engine) => {
		await loadFull(engine);
	}, []);

	//LAS FUNCIONES crearPreRegistroStripe y Kueski nos ayudan a crear el json para procesar el resgistro en SAI correctamente ya que algunos campos varían.

	const crearPreRegistroStripe = (esCompraExterna) => {
		const { id: folioPago, amount } = paymentIntent;

		const { card: { last4, funding } } = paymentMethod;

		return {
			folioContrato,
			region: formValues.region,
			metodoPago: stripeSession.metadata.metodoPago,
			tipoPago: "compra",
			montoCobro: amount / 100,
			esCompraExterna,
			tipoTarjeta: funding,
			codigoAplicado,
			idCodigoDescuento,
			folioPago,
			estado: formValues.estado,
			municipio: formValues.ciudad,
			datosCliente: {
				nombre: formValues.nombre,
				apellidoPaterno: formValues.apellidoPaterno,
				apellidoMaterno: formValues.apellidoMaterno,
				calle: formValues.calle,
				colonia: formValues.colonia,
				numeroExterior: formValues.region !== 1 ? '07206' : formValues.numeroExterior,
				numeroInterior: formValues.numeroInterior,
				codigoPostal: formValues.region !== 1 ? '07206' : formValues.codigoPostal,
				email: formValues.correo,
				numeroTelefono: formValues.numeroTelefono,
			},
		};
	}

	const crearPreRegistroKueski = (esCompraExterna) => {
		
		return {
			folioContrato,
			region: formValues.region,
			metodoPago: kueskiSession.metadata.metodoPago,
			tipoPago: "compra",
			montoCobro: kueskiAmount / 100,
			esCompraExterna,
			tipoTarjeta: "credit",
			codigoAplicado,
			idCodigoDescuento,
			folioPago: kueskiSession.payment_intent,
			estado: formValues.estado,
			municipio: formValues.ciudad,
			datosCliente: {
				nombre: formValues.nombre,
				apellidoPaterno: formValues.apellidoPaterno,
				apellidoMaterno: formValues.apellidoMaterno,
				calle: formValues.calle,
				colonia: formValues.colonia,
				numeroExterior: formValues.numeroExterior,
				numeroInterior: formValues.numeroInterior,
				codigoPostal: formValues.codigoPostal,
				email: formValues.correo,
				numeroTelefono: formValues.numeroTelefono,
			},
		};
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		//Se reciben los datos para manejarlos en la vista pública
		const param = new URLSearchParams(window.location.search);

		let esCompraExterna = param.get("compraExterna");

		if(esCompraExterna === 'true'){
			console.log("Es compra externa")
			esCompraExterna = true;
		}else{
			esCompraExterna = false;
		}
		//Transformamos el string del data en arreglo

		//Si la variable datosURL es diferente de null es una compra fuera de México

		try {
			setLoading(true);

			if (camposVacios) {
				await validarCamposVacios({
					formValues,
					isCreditoDirecto,
					setCamposVacios,
					setEventKey,
					metodoPago: compraKueski ? kueskiSession.metadata.metodoPago : stripeSession.metadata.metodoPago,
				});
			}
		} catch (error) {
			console.log("algo sucedió al completar el pre-registro: ", error);

			setEventKey("");

			setLoading(false);

			return NotificationManager.error(error);
		}


		try {
			
			
			const dataPreRegistro = compraKueski === true ? crearPreRegistroKueski(esCompraExterna) : crearPreRegistroStripe(esCompraExterna);
			
			const { idsLocalidad, jsonPreRegistro } = await validarDatosPreRegistro(dataPreRegistro);


			await procesarDatosPreRegistro(jsonPreRegistro);
			
			await actualizarDatosFirma({
				idRegion: formValues.region,
				folioContrato,
				firmaBase64: formValues.firma,
				clienteFirma: {
					edad: formValues.edad,
					estadoCivil: formValues.estadoCivil,
					calle: formValues.calle,
					referencia: formValues.entreCalles,
					colonia: formValues.colonia,
					codigoPostal: formValues.codigoPostal,
					idEstadoCliente: idsLocalidad.idEstado,
					idMunicipioCliente: idsLocalidad.idMunicipio,
					tiempoDomicilio: formValues.tiempoResidencia,
					nombreReferencia1: formValues.nombreReferencia1,
					parentescoReferencia1: formValues.parentescoReferencia1,
					telefonoReferencia1: formValues.numeroTelefonoReferencia1 !== '' ? formValues.numeroTelefonoReferencia1 : '(477) 000-00-00',
					nombreReferencia2: formValues.nombreReferencia2,
					parentescoReferencia2: formValues.parentescoReferencia2,
					telefonoReferencia2: formValues.numeroTelefonoReferencia2 !== '' ? formValues.numeroTelefonoReferencia2 : '(477) 000-00-01',
					horariosLaborales: compraKueski ? '' : stripeSession.metadata.metodoPago !== 'credito' ? '' : `De ${formValues.inicioHorarioLaboral} a ${formValues.finHorarioLaboral}`,
				},
			});

			if(!compraKueski) {
				if (stripeSession.metadata.metodoPago === typesMetodosPago.CREDITO) {
					const arrayJSONFotos = await getArrayJsonCargaImagenes({
						idRegion: formValues.region,
						folioContrato,
						imagesData: {
							caraFrontalIne: formValues.caraFrontalIne,
							caraPosteriorIne: formValues.caraPosteriorIne,
							caraFrontalTarjeta: formValues.caraFrontalTarjeta,
						},
					});
	
					await subirFotosSai(arrayJSONFotos);
	
					const domiciliacionReplacementes = await getTemplateReplacements({
						formValues,
						precios
					});
					
					await generarDocumentoDomiciliacion({ folioContrato, replacements: domiciliacionReplacementes, idRegion: formValues.region });
				}
			}

			if(!compraKueski) {
				await enviarComprobante({
					titular: `${formValues.nombre} ${formValues.apellidoPaterno} ${ formValues.apellidoMaterno }`,
					paymentIntentId: compraKueski ? paymentIntent.id : kueskiSession.payment_intent,
					folioContrato,
					montoCobro: compraKueski ? kueskiAmount / 100 : paymentIntent.amount / 100,
					numeroTarjeta: `Tarjeta con terminación ${compraKueski ? 'XXXX' : paymentMethod.card.last4}`,
					description: `Compra de Licencia Click+ - Folio ${folioContrato}`,
					correo: formValues.correo
				}, formValues, contextValue.compra, paymentMethod, paymentIntent, compraLectura, formValues.region !== 1 ? true : false);
			}else{
				await enviarComprobanteKueski({
					titular: `${formValues.nombre} ${formValues.apellidoPaterno} ${ formValues.apellidoMaterno }`,
					paymentIntentId: compraKueski ? paymentIntent.id : kueskiSession.payment_intent,
					folioContrato,
					montoCobro: compraKueski ? kueskiAmount / 100 : paymentIntent.amount / 100,
					numeroTarjeta: `Tarjeta con terminación ${compraKueski ? 'XXXX' : paymentMethod.card.last4}`,
					description: `Compra de Licencia Click+ - Folio ${folioContrato}`,
					correo: formValues.correo
				}, formValues, kueskiSession, kueskiAmount, compraLectura);
			}

			setContextValue({
				...contextValue,
				compra: {
					...contextValue.compra,
					correo: formValues.correo
				}
			});

			history.replace(dashboardRoutesPaths.pagos.compra.compraFinalizada + `?region=${formValues.region}`);
		} catch (error) {
			console.log("Error al validar los datos para el pre-registro: ", error);

			if (typeof error.data === 'string' && error.data.includes('El folio del contrato ya existe')) {
				NotificationManager.error(error.data);
			}

			if (error.message) {
				NotificationManager.error(error.message);
			}

			setLoading(false);
		}
	};

	const consultarPaymentData = async () => {
		try {
			const { paymentIntent, paymentMethod } = await retrievePaymentIntent(stripeSession.payment_intent);
			setPaymentIntent(paymentIntent);

			setPaymentMethod(paymentMethod);
			
			setShowLoader(!showLoader);
		} catch (error) {}
	};

	useEffect(() => {
		// generarDocumentoDomiciliacion({
		// 	folioContrato: "666",
		// 	replacements: {
		// 		tipoLicencia: "Licencia Click+ Premium",
		// 		nombreBanco: "BanBajío",
		// 		numeroTarjeta: "4242 4242 4242 4242",
		// 		montoMaximo: "19,990.00",
		// 		montoFijo: "600.00",
		// 		nombreTitular: "Sergio Antonio Hernandez Ramirez",
		// 		firmaTitular: "data:image/png;base64,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",
		// 		diasPago: "Días 1 y 15",
		// 		fechaVencimiento: "11 de Mayo del 2025"
		// 	}
		// });

		//Se reciben los datos para manejarlos en la vista pública
		const param = new URLSearchParams(window.location.search);

		let esCompraExterna = param.get("compraExterna");

		if(esCompraExterna === 'true'){
			setCompraExterna(true);
		}else{
			setCompraExterna(false);
		}

		if (stripeSession) {
			if (stripeSession.metadata.metodoPago === typesOpcionesPagoCompra.credito) {
				setIsCreditoDirecto(true);
			}

			consultarPaymentData();
		}else{
			setShowLoader(!showLoader);
		}

		// setTimeout(() => setShowLoader(!showLoader), 1500);
	}, []);

	useEffect(() => {
		if (eventKey !== "" && eventKey !== "4") {
			buttonRef.current?.click();
		}
	}, [eventKey]);

	useEffect(() => {
		if(compraExterna) {
			setFormValues({
				...formValues,
				codigoPostal: '07206',
				numeroExterior: '0000'
			})
		}
	}, [formValues]);

	return showLoader ? (
		<Loader />
	) : (
		<>
			<Particles options={particlesOptions} init={particlesInit} id="tsparticles" />

			<Animated animationIn="fadeIn" isVisible={true}>
				<div id="particles" className="container-form-registro">
					<Navbar style={{ backgroundColor: "transparent!important" }}>
						<Container fluid>
							<Row>
								<Col>
									<Navbar.Brand href="#home">
										<Image src={require("@assets/images/logo-gc-horizontal.png")} width={150} />
									</Navbar.Brand>
								</Col>
							</Row>
						</Container>
					</Navbar>

					<Container fluid="md" className="pb-4">
						<Row>
							<Col>
								<Card body className="card-form-registro">
									<Container fluid id="container-card" className="">
										<Row className="d-flex align-items-stretch">
											<Col xs={12} lg={5} xl={4} className="px-0 px-lg-auto">
												<div className="img-bg-form-registro sai"></div>
											</Col>

											<Col xs={12} lg={7} xl={8} className="px-0">
												<Form className="form-registro-sai p-md-2" onSubmit={handleSubmit}>
													<Container fluid className="text-white">
														<TitleDashboard title="Comienza tu Registro" />

														<Typography variant="overline">Llena el siguiente formulario para comenzar con tu registro en Click+</Typography>

														<Accordion className="ms-lg-3 my-3 form-accordion" defaultActiveKey="1" flush data-bs-theme="dark">
															<AccordionDatosPersonales formValues={formValues} setFormValues={setFormValues} />

															{compraExterna ? (
																<AccordionDatosDomicilioExterno compraLectura={compraLectura} formValues={formValues} setFormValues={setFormValues} isCreditoDirecto={isCreditoDirecto} />
															): (
																<AccordionDatosDomicilio compraLectura={compraLectura} formValues={formValues} setFormValues={setFormValues} isCreditoDirecto={isCreditoDirecto} />
															)}

															{/* <AccordionDatosDomicilio compraLectura={compraLectura} formValues={formValues} setFormValues={setFormValues} isCreditoDirecto={isCreditoDirecto} /> */}

															{isCreditoDirecto ? <AccordionDatosCredito formValues={formValues} setFormValues={setFormValues} /> : null}

															<AccordionAutorizacionContrato
																loading={loading}
																formValues={formValues}
																setFormValues={setFormValues}
																isCreditoDirecto={isCreditoDirecto}
																buttonRef={buttonRef}
																eventKey={eventKey}
															/>
														</Accordion>
													</Container>
												</Form>
											</Col>
										</Row>
									</Container>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</Animated>
		</>
	);
};

export default FormularioRegistroSAI;
